<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template>
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile()"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-inOutRecord' }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header'
import PageMain from './main.vue'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      currSearchForm: {},
      chooseTemplateOptions: { visible: false },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSkuInvFtyLogListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.currSearchForm = form
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    exportFile() {
      if (!this.tableData || !this.tableData.length) {
        this.$message({
          message:
            this.$l('tips_exportEmptyData') ||
            '当前条件无匹配库存数据，请修改查询后重试！',
          type: 'warning',
        })
        return
      }


      const listChangeLogId =
        this.checkedRows?.map((item) => item.changeLogId) || []
      const searchForm = {
        ...this.currSearchForm,
        listChangeLogId,
      }

      this.chooseTemplateOptions = { visible: true, searchForm }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
